import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
} from "react-hook-form";
import { whiteCheckIcon } from "../../../../assets/svgs/icons/icons.svg";
import Button from "../../../global/Button/Button";
import InputSection from "../../../global/InputSection/InputSection";
import TextAreaSection from "../../../global/TextAreaSection/TextAreaSection";

import {
  EtablissementValidationType,
  Localisation
} from "../../../../schemas-and-types/etablissement/etablissemen.schema";
import DropdownSection from "../../../global/DropdownSection/DropdownSection";

import MapsSearchSection from "../../../global/MapsSearchSection/MapsSearchSection";
import PhoneSection from "../../../global/PhoneSection/PhoneSection";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "./InformationEtabModification.module.scss";

type Props = {
  // react-hook-form
  register: UseFormRegister<EtablissementValidationType>;
  formErrors: FieldErrors<EtablissementValidationType>;
  setIsInfoEtabModification: React.Dispatch<React.SetStateAction<boolean>>;
  setError: UseFormSetError<EtablissementValidationType>;
  clearErrors: UseFormClearErrors<any>;

  setRegisterValue: UseFormSetValue<any>; // TODO : Remove 'any' type

  // related to dropdowns
  typeEtablissementsOptions: any; // TODO remove any type
  areTypeEtabOptionsLoading: boolean;
  regionsOptions: any; // TODO remove any type
  areRegionOptionsLoading: boolean;
  // set type etablissement to set the metier list to display (with or without 'Animation' section)

  // localisation
  setLocalisationOption: React.Dispatch<React.SetStateAction<Localisation>>;
  localisationOption: Localisation;

  onClickEnregister?: () => void;
};
export default function InformationEtabModification(props: Props) {
  const {
    register,
    formErrors,
    setError,
    clearErrors,
    setRegisterValue,

    setIsInfoEtabModification,
    typeEtablissementsOptions,
    areTypeEtabOptionsLoading,
    regionsOptions,
    areRegionOptionsLoading,

    setLocalisationOption,
    localisationOption,
    onClickEnregister,
  } = props;
  const { t } = useTranslation();

  const navigate = useNavigate();
  function onClickAnnulerModification() {
    setIsInfoEtabModification(false);
    navigate(0);
  }

  return (
    <article className={styles.informationEtabModification}>
      <header className={styles.informationEtabModification__header}>
        <h2>{t('pages.etablissement.recapitulatif.informationEtabModification.title')} *</h2>
      </header>
      <main className={styles.informationEtabModification__main}>
        <article className={styles.informationEtabModification__top}>
          <section className={styles.informationEtabModification__top__left}>
            <section>
              <DropdownSection
                options={typeEtablissementsOptions?.data?.list || []}
                label={t('pages.etablissement.recapitulatif.informationEtabModification.typeEtablissement')}
                inputId="inscriptionEtab_infoEtab_type"
                placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.selectTypeEtablissement')}
                name="type"
                register={register}
                formErrors={formErrors}
                areOptionsLoading={areTypeEtabOptionsLoading}
              />
            </section>
            <section>
              <InputSection
                label={t('pages.etablissement.recapitulatif.informationEtabModification.nameEtablissement')}
                inputId="modificationEtab_nom"
                inputType="text"
                placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.nameEtablissement')}
                name="name"
                required
                register={register}
                formErrors={formErrors}
              />
              <MapsSearchSection
                label={t('pages.etablissement.recapitulatif.informationEtabModification.adresseEtablissement')}
                inputId="inscriptionEtab_infoEtab_adresse"
                placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.adresseEtablissement')}
                name="address"
                register={register}
                formErrors={formErrors}
                setError={setError}
                clearErrors={clearErrors}
                localisationOption={localisationOption}
                setLocalisationOption={setLocalisationOption}
                setRegisterValue={setRegisterValue}
              />
            </section>
            <section>
              <TextAreaSection
                label={t('pages.etablissement.recapitulatif.informationEtabModification.textAreaSection.label')}
                textAreaId="modificationEtab_access"
                placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.textAreaSection.placeholder')}
                name="information_access"
                required
                register={register}
                formErrors={formErrors}
              />
            </section>
          </section>
          <section
            className={styles.informationEtabModification__top__separationLine}
          ></section>
          <section className={styles.informationEtabModification__top__right}>
            <section>
              <DropdownSection
                options={regionsOptions?.data?.list || []}
                label={t('pages.etablissement.recapitulatif.informationEtabModification.dropDownSection.label')}
                inputId="inscriptionEtab_region"
                placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.dropdownSection.placeholder')}
                name="region"
                register={register}
                formErrors={formErrors}
                areOptionsLoading={areRegionOptionsLoading}
              />
            </section>
            <section id="section1 name_dr">
              <InputSection
                label={t('pages.etablissement.recapitulatif.informationEtabModification.lastName_dr.label')}
                inputId="modificationEtab_nomDR"
                inputType="text"
                placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.lastName_dr.placeholder')}
                name="nom_dr"
                required
                register={register}
                formErrors={formErrors}
              />

              <InputSection
                label={t('pages.etablissement.recapitulatif.informationEtabModification.firstName_dr.label')}
                inputId="modificationEtab_prenomDR"
                inputType="text"
                placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.firstName_dr.placeholder')}
                name="prenom_dr"
                required
                register={register}
                formErrors={formErrors}
              />
            </section>
          </section>
        </article>

        <section className={styles.informationEtabModification__bottom}>
          <article className={styles.informationEtabModification__bottom__DE}>
            <h2>{t('pages.etablissement.recapitulatif.informationEtabModification.facilityManagerTitle')} Informations Directeur(trice) d'établissement *</h2>
            <main>
              <section id="name_de">
                <InputSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.lastName_de.label')}
                  inputId="modificationEtab_nomDE"
                  inputType="text"
                  placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.lastName_de.placeholder')}
                  name="nom_de"
                  required
                  register={register}
                  formErrors={formErrors}
                />

                <PhoneSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.phone.label')}
                  inputId="modificationEtab_phoneDE"
                  placeholder="0 00 00 00 00"
                  name="phone_de"
                  required
                  register={register}
                  formErrors={formErrors}
                  setRegisterValue={setRegisterValue}
                />
              </section>
              <section>
                <InputSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.firstName_de.label')}
                  inputId="modificationEtab_prenomDE"
                  inputType="text"
                  placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.firstName_de.placeholder')}
                  name="prenom_de"
                  required
                  register={register}
                  formErrors={formErrors}
                />
                <InputSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.email_referent.label')}
                  inputId="modificationEtab_emailDE"
                  inputType="text"
                  placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.email_referent.placeholder')}
                  name="email_de"
                  required
                  register={register}
                  formErrors={formErrors}
                />
              </section>
            </main>
          </article>
          <article className={styles.informationEtabModification__bottom__REF}>
            {/* INFORMATIONS DES REFERENTS  */}
            <h2>{t('pages.etablissement.recapitulatif.informationEtabModification.title')}</h2>
            <main>
              <section>
                <InputSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.lastName_referent.label')}
                  inputId="modificationEtab_nomRef"
                  inputType="text"
                  placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.lastName_referent.placeholder')}
                  name="nom_referent"
                  required
                  register={register}
                  formErrors={formErrors}
                />

                <InputSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.email_referent.label')}
                  inputId="modificationEtab_emailRef"
                  inputType="text"
                  placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.email_referent.placeholder')}
                  name="email_referent"
                  required
                  register={register}
                  formErrors={formErrors}
                />
              </section>
              <section>
                <InputSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.firstName_referent.label')}
                  inputId="modificationEtab_prenomRef"
                  inputType="text"
                  placeholder={t('pages.etablissement.recapitulatif.informationEtabModification.firtsName_referent.placeholder')}
                  name="prenom_referent"
                  required
                  register={register}
                  formErrors={formErrors}
                />

                <PhoneSection
                  label={t('pages.etablissement.recapitulatif.informationEtabModification.phone.label')}
                  inputId="modificationEtab_emailRef"
                  placeholder="0 00 00 00 00"
                  name="phone_referent"
                  required
                  register={register}
                  formErrors={formErrors}
                  setRegisterValue={setRegisterValue}
                />
              </section>
            </main>
          </article>
        </section>
      </main>
      <footer className={styles.informationEtabModification__footer}>
        <Button
          buttonBackGroundColor="white"
          text={t('common.cancel')}
          textColor="dark"
          onClick={onClickAnnulerModification}
        />
        <Button
          buttonBackGroundColor="blue"
          text={t('common.validate')}
          textColor="white"
          type="submit"
          icon={whiteCheckIcon}
          onClick={onClickEnregister && onClickEnregister}
        />
      </footer>
    </article>
  );
}
